import { partnersMap } from '@/utils/partnership';
import { useFields } from './useFields';

export const usePartnership = () => {
  const fields = useFields();
  const partnership = `${fields?.partner}`;
  return partnersMap.get(partnership);
};
